export const societiesQueryKeys = {
	all: ["societies"] as const,
	lists: () => [...societiesQueryKeys.all, "lists"] as const,
	listSyndics: (search: string) =>
		[...societiesQueryKeys.lists(), "syndics", search] as const,
	listInsurers: (search: string) =>
		[...societiesQueryKeys.lists(), "insurers", search] as const,
	listTPAs: (search: string) =>
		[...societiesQueryKeys.lists(), "tpas", search] as const,
	broker: (id: number) => [...societiesQueryKeys.all, "broker", id] as const,
	brokerCommunications: (
		brokerId: number | string,
		params?: {
			page?: number;
			limit?: number;
			sortBy?: string;
			sortOrder?: string;
		},
	) =>
		[
			...societiesQueryKeys.all,
			"broker-communications",
			brokerId,
			params,
		] as const,
	brokerCommunicationsAll: (brokerId: number | string) =>
		[...societiesQueryKeys.all, "broker-communications", brokerId] as const,
	societiesBrokers: (
		search?: string,
		status?: string,
		page?: number,
		limit?: number,
	) =>
		[
			...societiesQueryKeys.all,
			"brokers",
			search,
			status,
			page,
			limit,
		] as const,
	brokerDetails: (id?: string) =>
		[...societiesQueryKeys.all, "broker-details", id] as const,
	brokerDocuments: (brokerId: number | string) =>
		[...societiesQueryKeys.all, "broker-documents", brokerId] as const,
	brokerUsers: (brokerId: number) =>
		[...societiesQueryKeys.all, "users", brokerId] as const,
	brokerEntities: (brokerId: number) =>
		[...societiesQueryKeys.all, "entities", brokerId] as const,
	brokerTasks: (brokerId: number | string) =>
		[...societiesQueryKeys.all, "broker-tasks", brokerId] as const,
	brokerProducts: (brokerId: number) =>
		[...societiesQueryKeys.all, "broker-products", brokerId] as const,
	brokerAccounting: (id: number) =>
		[...societiesQueryKeys.broker(id), "accounting"] as const,
	societyFiles: (societyId: number, type?: string) =>
		[...societiesQueryKeys.all, "files", societyId, type] as const,
};
